const ROWS: Array<[string, string]> = [
  ['ECS task definition', 'Replaced on every deploy. Image, environment, secrets, size, architecture.'],
  ['ECS service, or EventBridge rules', 'One service, or one rule per scheduled job.'],
  ['ALB target group', 'Named after the service, with the health check from the manifest.'],
  ['ALB listener rule', 'Host header and path conditions, at a priority derived from the service name.'],
  ['CloudWatch log group', 'Retained on stack deletion by default.'],
  ['Auto-scaling target and policies', 'CPU, memory and request-count target tracking.'],
  ['Task security group', 'Only when `network.securityGroups` is omitted.'],
  ['Task and execution IAM roles', 'Only when `roles` is omitted.'],
];

export function Split() {
  return (
    <section id="ownership">
      <h2>What the stack owns</h2>
      <p className="lede">
        Everything below belongs to one CloudFormation stack per manifest, and is deleted cleanly
        when that stack is deleted. Nothing outside it is touched.
      </p>

      <div className="table-wrap">
        <table>
          <thead>
            <tr>
              <th>Resource</th>
              <th>Notes</th>
            </tr>
          </thead>
          <tbody>
            {ROWS.map(([what, note]) => (
              <tr key={what}>
                <td>
                  <strong>{what}</strong>
                </td>
                <td className="muted">{note}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
